import React from "react";

import FieldWithTooltip from "@/Components/Tooltip/FieldWithToolTip";

function UsernameWithTooltip(): React.JSX.Element {
  const description = `Your username is a unique identifier that represents you within our app. It cannot be changed once set.   `;

  return <FieldWithTooltip label={"Username"} description={description} />;
}

export default UsernameWithTooltip;
